import { render, staticRenderFns } from "./CertificadorBHP.vue?vue&type=template&id=81394db2&"
import script from "./CertificadorBHP.vue?vue&type=script&lang=ts&"
export * from "./CertificadorBHP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('81394db2', component.options)
    } else {
      api.reload('81394db2', component.options)
    }
    module.hot.accept("./CertificadorBHP.vue?vue&type=template&id=81394db2&", function () {
      api.rerender('81394db2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CertificadorBHP/CertificadorBHP.vue"
export default component.exports